'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PREFIX = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _card = require('../card');

var _card2 = _interopRequireDefault(_card);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_style2.default);

var PREFIX = exports.PREFIX = 'xsui-card-with-image';

var CardBanner = function CardBanner(_ref) {
  var image = _ref.image,
      badge = _ref.badge,
      children = _ref.children,
      footer = _ref.footer,
      className = _ref.className,
      badgeDataId = _ref.badgeDataId,
      imageDataId = _ref.imageDataId;
  return _react2.default.createElement(
    _card2.default,
    { className: className },
    function () {
      return _react2.default.createElement(
        'div',
        { className: cx(PREFIX) },
        _react2.default.createElement(
          'div',
          { className: cx(PREFIX + '__body') },
          _react2.default.createElement('img', { src: image, className: cx(PREFIX + '__image'), 'data-id': imageDataId, alt: '' }),
          badge && _react2.default.createElement(
            'div',
            { className: cx(PREFIX + '__badge'), 'data-id': badgeDataId },
            badge
          ),
          children
        ),
        footer && footer
      );
    }
  );
};

CardBanner.propTypes = {
  className: _propTypes2.default.string,
  image: _propTypes2.default.string.isRequired,
  badge: _propTypes2.default.string,
  children: function children() {
    return (typeof _react.bpfrpt_proptype_Node === 'function' ? _react.bpfrpt_proptype_Node.isRequired ? _react.bpfrpt_proptype_Node.isRequired : _react.bpfrpt_proptype_Node : _propTypes2.default.shape(_react.bpfrpt_proptype_Node).isRequired).apply(this, arguments);
  },
  footer: function footer() {
    return (typeof _react.bpfrpt_proptype_Node === 'function' ? _react.bpfrpt_proptype_Node : _propTypes2.default.shape(_react.bpfrpt_proptype_Node)).apply(this, arguments);
  },
  badgeDataId: _propTypes2.default.string,
  imageDataId: _propTypes2.default.string
};
exports.default = CardBanner;